import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.div`
  padding: 15px 50px 30px 50px;
  margin-top: 60px;

  > a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    color: #dee2e6;
    transition: text 0.2s;

    &:hover {
      color: ${lighten(0.7, '#dee2e6')};
      text-decoration: underline;
    }
  }

  /* Parte responsiva */
  @media (max-width: 600px) {
    padding: 30px 10px 60px 10px;
  }
`;

export const Info = styled.div`
  color: #02a499;
  background: rgba(2, 164, 153, 0.2);
  padding: 10px;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 30px;
`;
